import { WikiPage, WikiPageSearchResult, Space, NewSpaceRequest, PageNode } from '../../interfaces/wiki/Wiki';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

// --- Space Endpoints ---

// Function to get all spaces
export async function getAllSpaces(
  authToken: string
): Promise<Space[] | null> {
  try {
    const response = await fetch(`${API_BASE_URL}/wiki/spaces`, {
      headers: {
        'Authorization': `Bearer ${authToken}`,
      },
    });

    if (!response.ok) {
      console.error('Failed to fetch spaces:', response.status, response.statusText);
      return null;
    }
    return await response.json();
  } catch (error) {
    console.error('Error fetching spaces:', error);
    return null;
  }
}

// Function to create a new space
export async function createSpace(
  authToken: string,
  newSpace: NewSpaceRequest
): Promise<Space | null> {
  try {
    const response = await fetch(`${API_BASE_URL}/wiki/spaces`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${authToken}`,
      },
      body: JSON.stringify(newSpace),
    });

    if (!response.ok) {
      console.error('Failed to create space:', response.status, response.statusText);
      return null;
    }
    return await response.json();
  } catch (error) {
    console.error('Error creating space:', error);
    return null;
  }
}

// Function to get the page hierarchy for a space
export async function getPageTreeForSpace(
  authToken: string,
  spaceId: string
): Promise<PageNode[] | null> {
  try {
    const response = await fetch(`${API_BASE_URL}/wiki/spaces/${spaceId}/pages/tree`, {
      headers: {
        'Authorization': `Bearer ${authToken}`,
      },
    });

    if (!response.ok) {
      console.error(`Failed to fetch page tree for space ${spaceId}:`, response.status, response.statusText);
      return null;
    }
    return await response.json();
  } catch (error) {
    console.error(`Error fetching page tree for space ${spaceId}:`, error);
    return null;
  }
}

// --- Permission Endpoints ---

// Function to add a user to a space
export async function addUserToSpace(
  authToken: string,
  spaceId: string,
  userId: string,
  role: string
): Promise<boolean> {
  try {
    const response = await fetch(`${API_BASE_URL}/wiki/spaces/${spaceId}/permissions`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${authToken}`,
      },
      body: JSON.stringify({ userId, role }),
    });

    return response.ok;
  } catch (error) {
    console.error(`Error adding user ${userId} to space ${spaceId}:`, error);
    return false;
  }
}

// Function to remove a user from a space
export async function removeUserFromSpace(
  authToken: string,
  spaceId: string,
  userId: string
): Promise<boolean> {
  try {
    const response = await fetch(`${API_BASE_URL}/wiki/spaces/${spaceId}/permissions/${userId}`, {
      method: 'DELETE',
      headers: {
        'Authorization': `Bearer ${authToken}`,
      },
    });

    return response.ok;
  } catch (error) {
    console.error(`Error removing user ${userId} from space ${spaceId}:`, error);
    return false;
  }
}
